const sections = [
  {
    title: "测评内容",
    links: [
      { href: "#reviews", label: "外卖测评" },
      { href: "#reviews", label: "家常复刻" },
      { href: "#stores", label: "探店实录" },
      { href: "#unbox", label: "美食开箱" },
    ],
  },
  {
    title: "浏览导航",
    links: [
      { href: "#ranking", label: "人气榜单" },
      { href: "#method", label: "测评方法" },
      { href: "#faq", label: "常见问答" },
      { href: "#subscribe", label: "订阅与投稿" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-900 text-secondary-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="flex flex-col gap-4 lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-secondary-950">
                <i className="ri-e-bike-2-line text-lg" aria-hidden="true" />
              </span>
              <strong className="font-heading text-lg font-bold text-background-50">美味的快递</strong>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-secondary-200">
              一个专注外卖、探店、美食开箱与推荐的中文测评站。我们记录价格、用时与真实体验，帮你在点单和出门前少踩一点雷。
            </p>
            <div className="flex flex-wrap gap-2">
              <span className="rounded-full bg-secondary-800 px-3 py-1 text-xs text-secondary-100">测评</span>
              <span className="rounded-full bg-secondary-800 px-3 py-1 text-xs text-secondary-100">外卖探店</span>
              <span className="rounded-full bg-secondary-800 px-3 py-1 text-xs text-secondary-100">美食开箱</span>
              <span className="rounded-full bg-secondary-800 px-3 py-1 text-xs text-secondary-100">推荐</span>
            </div>
          </div>

          {sections.map((section) => (
            <nav key={section.title} aria-label={section.title} className="flex flex-col gap-3">
              <h3 className="font-heading text-sm font-bold text-background-50">{section.title}</h3>
              <ul className="flex flex-col gap-2">
                {section.links.map((link) => (
                  <li key={`${section.title}-${link.label}`}>
                    <a
                      href={link.href}
                      className="text-sm text-secondary-200 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-700 pt-6 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 美味的快递 · 本页内容为独立测评与推荐，不提供下单或预订功能。</p>
          <p>价格与营业时间以测评当时记录为准，实际可能变化。</p>
        </div>
      </div>
    </footer>
  );
}